import MerchandiseSearchForm from 'components/Merchandise/MerchandiseSearch/MerchandiseSearchForm'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { useGlobalMerchandiseSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalMerchandiseSearch'
import React from 'react'

function GlobalMerchandiseSearchTabContent() {
  const [dispatch, state] = useGlobalMerchandiseSearchContext()

  return <GlobalSearchContextProvider
    state={state}
    dispatch={dispatch}
  >
    <MerchandiseSearchForm />
  </GlobalSearchContextProvider>
}

export default GlobalMerchandiseSearchTabContent
